module.exports = __webpack_public_path__ + "img/skin.99b7e67e.jpg";